<template>
  <div class="order-list">
    <div
      class="order-item"
      v-for="item in items"
      :key="item.orderId"
      @click="goLogList(item)"
    >
      <div class="tite-line">订单号：{{ item.orderId }}</div>
      <div class="info-line">雇主：{{ item.userName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    goLogList(item) {
      const editableList = [20, 30, 40]
      const index = editableList.indexOf(item.orderState)
      const type = index >= 0 ? 2 : 1
      location.href = `/v/service-log/list/2/${type}/${item.orderId}?name=${item.userName}&cmd=share&sharetype=0&refresh=no`
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mixin';
.order-list {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .order-item {
    background-color: #ffffff;
    padding: 0 rem(30px) rem(10px);
    width: rem(710px);
    margin-top: rem(20px);
    border-radius: rem(8px);
    .tite-line {
      height: rem(100px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 1px solid #f0f0f0;
    }
    .info-line {
      height: rem(90px);
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: rem(28px);
      color: #666666;
    }
  }
}
</style>
